import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { jwtDecode } from 'jwt-decode';
import { JwtCustomPayload } from '~app/common/models/jwt-payload';
import { authConstants } from '../constants/auth.constants';
import { Role } from '../models/role';

@Injectable({
    providedIn: 'root',
})
export class SendCustomerAuthService {
    jwtHelper = new JwtHelperService();

    public getToken(): string {
        return localStorage.getItem('sendCustomerToken') ?? '';
    }

    public getUserId(): string {
        const tokenPayload = this.decodeJwtPayload();

        return tokenPayload?.id;
    }

    public getSendCustomerUserId(): string {
        return this.getUserId();
    }

    public getUserName(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.firstName} ${tokenPayload.lastName}`;
    }

    public getFirstName(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.firstName}`;
    }

    public getLastName(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.lastName}`;
    }

    public getEmail(): string {
        const tokenPayload = this.decodeJwtPayload();

        return `${tokenPayload.sub}`;
    }

    public isAuthenticated(): boolean {
        const token = this.getToken();
        // Check whether the token is expired and return
        // true or false
        return !this.jwtHelper.isTokenExpired(token);
    }

    public isSendCustomerAuthenticated(): boolean {
        return this.isAuthenticated();
    }

    public isLoggedIn(): boolean {
        if (this.isAuthenticated()) {
            const tokenPayload = this.decodeJwtPayload();

            return tokenPayload?.roles.filter((role: Role) => role.name === authConstants.ROLE_USER).length > 0;
        }

        return false;
    }

    public logout(): void {
        localStorage.clear();
        sessionStorage.clear();
    }

    public decodeJwtPayload(): JwtCustomPayload {
        const token: string = this.getToken();

        return jwtDecode<JwtCustomPayload>(token);
    }
}
